// 角色管理
const RoleManageRouter =    {
  path: 'roleManage',
  name: 'RoleManage',
  meta: {
    requiresAuth: false,
    leftMenu: true
  },
  component: () => import('@/views/Setting/roleManage')
}
export default RoleManageRouter
